// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "container-2L3A1";
var _5 = "offer-2iEm4";
var _6 = "offer__fullscreen-uUQ7A";
var _7 = "offer__image-3t1HN";
var _8 = "offer__info-_XniD";
var _9 = "offer__info_title-30GDY";
var _a = "offer__info_description-3ktYO";
export { _1 as "__esModule", _2 as "tablet", _3 as "mobile", _4 as "container", _5 as "offer", _6 as "offer__fullscreen", _7 as "offer__image", _8 as "offer__info", _9 as "offer__info_title", _a as "offer__info_description" }
export default { "__esModule": _1, "tablet": _2, "mobile": _3, "container": _4, "offer": _5, "offer__fullscreen": _6, "offer__image": _7, "offer__info": _8, "offer__info_title": _9, "offer__info_description": _a }
